import { z } from 'zod';

const targetSchema = z.object({
  id: z.number(),
  title: z.string(),
  slug: z.string(),
});

export const previewClipTitleV1ResponseSchema = z.object({
  success: z.literal(true),
  data: z.object({
    action: z.enum([
      'no-change',
      'move',
      'move-and-soft-delete-source',
      'create',
      'create-and-soft-delete-source',
    ]),
    slug: z.string(),
    sourceTitle: z.string(),
    sourceClipCount: z.number(),
    target: targetSchema.optional(),
  }),
});

export type IPreviewClipTitleV1Response = z.infer<typeof previewClipTitleV1ResponseSchema>;
